import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { CreditCard, Banknote, Landmark, Smartphone, Wallet } from "lucide-react";
import { formatCurrency } from "../../lib/utils";

const ICONS = { cash: Banknote, card: CreditCard, transfer: Landmark, mobile: Smartphone };
const COLORS = { cash: "bg-emerald-500", card: "bg-blue-500", transfer: "bg-purple-500", mobile: "bg-orange-500" };

// Painel inicial: vendas de hoje por modalidade de pagamento e por TPA (terminal)
export const PaymentsTodayCard = ({ data }) => {
  const total = data?.total || 0;
  const methods = data?.by_method || [];
  const tpas = data?.by_tpa || [];
  return (
    <Card data-testid="payments-today-card">
      <CardHeader className="pb-2">
        <CardTitle className="font-['Outfit'] flex items-center gap-2 text-base md:text-lg">
          <Wallet className="w-5 h-5 text-primary" /> Pagamentos de hoje
          <span className="ml-auto font-mono text-sm text-emerald-500" data-testid="payments-today-total">{formatCurrency(total)}</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="grid md:grid-cols-2 gap-6">
        {!methods.length && <p className="text-sm text-muted-foreground text-center py-4 md:col-span-2">Sem pagamentos registados hoje</p>}
        <div className="space-y-2">
          {methods.map((m) => {
            const Icon = ICONS[m.method] || Wallet;
            const pct = total ? Math.round((m.total / total) * 100) : 0;
            return (
              <div key={m.method} data-testid={`payments-today-method-${m.method}`}>
                <div className="flex items-center justify-between text-sm">
                  <span className="flex items-center gap-2"><Icon className="w-4 h-4 text-muted-foreground" /> {m.label} <span className="text-xs text-muted-foreground">({m.count})</span></span>
                  <span className="font-mono font-medium">{formatCurrency(m.total)} <span className="text-xs text-muted-foreground">{pct}%</span></span>
                </div>
                <div className="h-1.5 rounded-full bg-muted mt-1 overflow-hidden"><div className={`h-full ${COLORS[m.method] || "bg-zinc-400"}`} style={{ width: `${pct}%` }} /></div>
              </div>
            );
          })}
        </div>
        {tpas.length > 0 && (
          <div className="space-y-1.5" data-testid="payments-today-tpas">
            <p className="text-[11px] uppercase tracking-wide text-muted-foreground">Por terminal (TPA)</p>
            <div className="grid grid-cols-2 gap-2">
              {tpas.map((t) => (
                <div key={t.tpa_id || "none"} className="rounded-lg border p-2.5" data-testid={`payments-today-tpa-${t.tpa_id || "none"}`}>
                  <p className="text-xs font-semibold truncate">{t.name}</p>
                  <p className="font-mono font-bold text-blue-500">{formatCurrency(t.total)}</p>
                  <p className="text-[11px] text-muted-foreground">{t.count} venda(s)</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
